// extracted by mini-css-extract-plugin
module.exports = {"courses":"dismantling_courses__13H2d","img1":"dismantling_img1__1donk","img2":"dismantling_img2__S-nIR","img3":"dismantling_img3__3CMCV"};